//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from '@/store'                    // 引入vuex数据
import BlInput from './bl-input'

export default {
  name: 'smsLogin',
  components: {
    BlInput
  },
  data () {
    return {
      timmer: '',
      isFirstStep: true,
      phone: '',     // 手机号码
      errorMessage: '',
      canPush: false, // 是否通过校验
      timeInterval: 60,  // 验证码获取cd
      busy: false,
      smscode: '', // 短信验证码
      verifTip: this.$t('flowLogin11'),
      timeRemain: 60,
      canGetVerifCode: true
    }
  },
  mounted () {
    // this.$_message(12)
  },
  methods: {
    // 获取验证码（手机/邮箱）
    getValidId () {
      console.log('getValidId')
      // let type = 1
      let exp = /^[+-]?\d*(\.\d*)?(e[+-]?\d+)?$/ // 手机
      if (!exp.test(this.phone)) {
        this.$_message('请输入正确的手机号~')
        return
      }
      if (this.timeRemain < 60  || !this.canGetVerifCode) return
      let data = {
        business: 3,
        phone: this.phone
      }
      this.$api.post('GET_SMS_VALIDATE', data, (res) => {
        if (res.code === 0) {
          this.canGetVerifCode = false
          this.timer = setInterval(() => {
            if (this.timeRemain > 1) {
              this.timeRemain--
              this.verifTip = `${this.$t('flowLogin83')}${this.timeRemain}s${this.$t('flowLogin12')}`
            } else {
              clearInterval(this.timer)
              this.timeRemain = 60
              this.canGetVerifCode = true
              this.verifTip = this.$t('flowLogin11')
              // this.verifTip = ''
            }
          }, 1000)
        }
      }, () => {
        clearInterval(this.timer)
        this.timeRemain = 60
        this.canGetVerifCode = true
        this.verifTip = this.$t('flowLogin11')
      })
    },
    close () {
      this.$emit('close')
    },
    doLogin (code) {
      let data = {}
      data.phone = this.phone
      data.smsCode = this.smscode
      if (!this.smscode) {
        this.$_message(this.$t('flowLogin76'))
        return
      }
      let qr = 'USER_LOGON'

      this.$api.post(qr, data, res => {
        this.$utils.cache('userData', JSON.stringify(res.data))
        this.$utils.cache('loginState', true)
        window.location.reload()
      })
    },
    btn () {
      if (!this.getCodeDisabled) {
        return
      }
      if (this.busy === true) return
      if (this.timeInterval < 60) return
      let data = {
        'phone': this.phone,
        business: 3
      }
      this.busy = true
      this.$api.post('GET_SMS_VALIDATE', data, (res) => {
        // this.close()
        this.busy = false
        if (res.code === 0) {
          this.isFirstStep = false
          this.errorMessage = ''
          this.timeInterval = 59
          this.timer = setInterval(() => {
            if (this.timeInterval > 1) {
              this.timeInterval--
            } else {
              clearInterval(this.timer)
              this.timeInterval = 60
            }
          }, 1000)
        } else {
          this.errorMessage = res.msg
          this.timeInterval = 60
        }
      }, error => {
        this.busy = false
        this.errorMessage = error.message
      })
    },
    // 会跳到第一步
    backToFirstStep () {
      this.isFirstStep = true
      clearInterval(this.timer)
      this.timeInterval = 60
    }
  },
  computed: {
    getCodeDisabled () {
      return Boolean(this.phone && this.phone.length)
    },
    canDoLogin () {
      return this.smscode && this.smscode.length === 6
    }
  },
  watch: {
    phone () {
      clearInterval(this.timer)
      this.canGetVerifCode = this.phone !== ''
      this.timeInterval = 60
      console.log(this.canGetVerifCode, 'canGetVerifCode')
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/sms-login.vue